import React from "react";
import ButtonEnhanced from "./ButtonEnhanced";

// Reusable "Limpiar Filtros" button shared by report screens (BusActivityTab,
// PlanningPage, etc). Keeps icon, label, and outline styling consistent.
export default function ClearFiltersButton({ onClick, disabled = false, style = {} }) {
  return (
    <ButtonEnhanced
      variant="outline"
      onClick={onClick}
      disabled={disabled}
      style={{ padding: "10px 20px", fontWeight: 600, ...style }}
      icon={
        <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
          <path d="M19.36,2.72L20.78,4.14L15.06,9.85C16.13,11.39 16.28,13.24 15.38,14.44L9.06,8.12C10.26,7.22 12.11,7.37 13.65,8.44L19.36,2.72M5.93,17.57C3.92,15.56 2.69,13.16 2.35,10.92L7.23,8.83L14.67,16.27L12.58,21.15C10.34,20.81 7.94,19.58 5.93,17.57Z" />
        </svg>
      }
    >
      Limpiar Filtros
    </ButtonEnhanced>
  );
}
